// extracted by mini-css-extract-plugin
export default {"timesBtns":"AuctionTimesBtns_timesBtns__T+Hjx"};